import React, { useState } from 'react';

import Modal from './modal';
import ReminderTable from './table';
import { Button } from 'components/ui/button';

export default function CompanyReminders() {
  const [showModal, setShowModal] = useState(false);

  return (
    <React.Fragment>
      <div className="d-flex justify-content-between align-items-start mb-6 mt-7">
        <div>
          <h6>Critical Date Reminders</h6>
          <p className="text-muted mb-0">Use reminders to notify your team of upcoming critical dates</p>
        </div>
        <div>
          <Button aria-label="addDefaultReminder" type="button" onClick={() => setShowModal(true)}>
            Add Reminder
          </Button>
          <Modal show={showModal} onHide={() => setShowModal(false)} />
        </div>
      </div>
      <ReminderTable />
    </React.Fragment>
  );
}
